<template>
	<Modal title="Amount Expended Details" modal-width="full-width">
		<DisabledForm />

		<fieldset class="dt-responsive table-responsive">
			<legend>Amount Expended:</legend>

			<Alert />

			<table id="dt-live-domd" class="table table-bordered nowrap">
				<thead>
					<tr>
						<!-- <th>NO</th> -->
						<th style="width: 10%; text-wrap-mode: wrap">Type</th>
						<th v-for="month in months" :key="'th_' + month.name">
							{{ month.value }}
						</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					<template v-if="Object.keys(expenditures).length">
						<tr v-for="type in expenditure_types" :key="'tm_' + type.name">
							<template v-if="expenditures[type.name]">
								<td>
									{{ type.value }}
								</td>
								<td v-for="month in months" :key="'tm_' + month.name">
									{{
										expenditures[type.name][month.name]
											? expenditures[type.name][month.name][0].total_amount
											: "0.00"
									}}
								</td>
								<td style="padding: 0">
									<button
										@click="
											deleteItem(Object.values(expenditures[type.name])[0][0])
										"
										class="btn btn-danger"
										style="border-radius: 0; width: 100%"
										:disable="isLoading"
									>
										<span
											v-if="isLoading"
											class="spinner-border spinner-border-sm"
											role="status"
										></span>
										<span v-else>Delete</span>
									</button>
								</td>
							</template>
						</tr>
					</template>
					<tr>
						<!-- <td>{{ index + 1 }}.</td> -->
						<td style="padding: 0">
							<select
								v-model="item_type"
								@change="updateItemType($event.target.value)"
								name="item_type"
								id="item_type"
							>
								<option value="">--select--</option>
								<option
									v-for="type in expenditure_types"
									:value="type.name"
									:key="'type_' + type.name"
								>
									{{ type.value }}
								</option>
							</select>
						</td>
						<td
							v-for="(month, index) in months"
							:key="'td_' + month.name"
							style="padding: 0"
						>
							<input
								@change="updateAmountReceived(month.name, $event.target.value)"
								:id="`${month.name}_${index}`"
								type="text"
								class="form-control"
								autofocus
								placeholder="Enter..."
							/>
						</td>
						<td style="padding: 0">
							<button
								@click="saveRecord()"
								class="btn btn-info"
								style="border-radius: 0; width: 100%"
								:disable="isLoading"
							>
								<span
									v-if="isLoading"
									class="spinner-border spinner-border-sm"
									role="status"
								></span>
								<span v-else>Save</span>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</fieldset>
	</Modal>
</template>

<script>
import { months, expenditure_types } from "@/utils/helpers.js";
import Modal from "@/components/Modal.vue";
import { EventBus } from "@/utils/event_bus.js";
import Alert from "@/components/Alert.vue";
import { mapActions, mapGetters } from "vuex";
import DisabledForm from "./DisabledForm.vue";
import Swal from "sweetalert2";

export default {
	components: {
		DisabledForm,
		Modal,
		Alert,
	},
	data() {
		return {
			item_type: "",
			approval_document_file_name: "",
			form: {
				report_id: this.$route.params.formID,
				report_type: "amount_expended",
				report_from: "",
				report_to: "",
				approval_document: "",
				approved_by: "",
				amount_data: [],
			},
		};
	},
	computed: {
		...mapGetters({
			isLoading: "shared/getLoading",
			expenditures: "form_ec16c/expenditures",
		}),
		months() {
			return months;
		},
		expenditure_types() {
			return expenditure_types;
		},
	},
	methods: {
		...mapActions({
			addForm: "form_ec16c/addForm",
			deleteFormRecord: "form_ec16c/deleteFormRecord",
			getFormDetails: "form_ec16c/getFormDetails",
		}),

		async saveRecord() {
			await this.addForm(this.form).then((res) => {
				if (res.status_code == 201) {
					this.clearFormInput();
				}
			});
		},

		updateAmountReceived(month, value) {
			const existingItemIndex = this.form.amount_data.findIndex(
				(item) => item.item_type === this.item_type && item.month === month
			);

			if (existingItemIndex === -1) {
				this.form.amount_data.push({
					item_type: this.item_type,
					month: month,
					total_amount: value,
				});
			} else {
				this.form.amount_data[existingItemIndex].total_amount = value;
			}
		},

		clearFormInput() {
			this.form.amount_data = [];
			this.item_type = "";

			this.months.forEach(
				(month, index) =>
					(document.getElementById(`${month.name}_${index}`).value = "")
			);
		},

		getAmountItems() {
			let payload = {
				type: this.form.report_type,
				formID: this.$route.params.formID,
			};

			this.getFormDetails(payload);
		},

		updateItemType(value) {
			if (Object.keys(this.form.amount_data).length) {
				this.form.amount_data.forEach((item) => {
					item.item_type = value;
				});
			}

			this.item_type = value;
		},

		deleteItem(item) {
			Swal.fire({
				title: `Delete ${item.item_type.toUpperCase()}?`,
				text: "This action cannot be undone!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#d33",
				cancelButtonColor: "#29623c",
				confirmButtonText: "Yes, delete!",
				cancelButtonText: "Cancel",
			}).then((result) => {
				if (result.isConfirmed) {
					this.sendDeleteRequest(item);
				}
			});
		},

		async sendDeleteRequest(item) {
			let payload = {
				report_id: item.party_annual_report_id,
				item_type: item.item_type,
				report_type: item.report_type,
			};
			await this.deleteFormRecord(payload).then((res) => {
				if (res.status_code == 200) {
					Swal.fire("Deleted!", res.data.message, "success");
				}
			});
		},
	},
	mounted() {
		this.getAmountItems();
		EventBus.$on("date-input", this.setDateInput);
		EventBus.$emit("toggle-modal", "show");
	},
};
</script>

<style scoped>
legend {
	background-color: #29623c;
	color: white;
	padding: 5px 10px;
}
.break-text {
	word-wrap: break-word;
	overflow-wrap: break-word;
	white-space: normal;
	padding: 0;
	padding-left: 2px;
	padding-top: 20px;
}
table {
	width: 100%;
	border-collapse: collapse;
}

td > input,
select {
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	border: none;
	padding-top: 20px;
	padding-left: 0;
	padding-right: 0;
	border-radius: 0;
	height: 100%;
}

.swal2-container {
	z-index: 1090 !important;
}

.modal {
	z-index: 1059 !important;
}
</style>
